import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const ReCenterContainer = styled.div`
  position: absolute;
  bottom: 60px;
  right: 12px;
  background-color: ${COLOR_OPTIONS.NEUTRAL_00};

  width: 32px;
  height: 32px;
  padding: 7px;
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  user-select: none;
`;
